const modalIcons = {
    cj: require('./cj.png'),
    flick: require('./flick.png'),
    bells: require('./bells.png')
}

export default modalIcons;